import React from "react";
// import { ReactComponent as Logo } from "@iso/assets/images/logo.svg";

function LazyLoading() {
    return (
        <div className="fixed top-0 left-0 loading-routes w-screen h-screen bg-primary-500 flex items-center justify-center z-50">
            <div className="animate-bounce">
                {/* <Logo /> */}
            </div>
        </div>
    );
}

export default LazyLoading;
